import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
const StudentCards = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  // Mock data - in a real app, this would come from an API
  useEffect(() => {
    // Simulating API fetch
    const fetchData = async () => {
       const mockUsers = await axios.get(`${API_BASE_URL}/api/products`);
      setTimeout(() => {
        // const mockUsers = [
        //   { id: 1, name: 'Karthik Prem', email: 'karthik@example.com', role: 'student', syllabus: 'CBSE', grade: '10', student_subject: 'ENGLISH', phone: '9876543210' },
        //   { id: 2, name: 'Alice Johnson', email: 'alice@example.com', role: 'tutor', qualification: 'M.A. English', tutor_subject: 'ENGLISH', experience: '5 years', phone: '1234567890' },
        //   { id: 3, name: 'Bob Smith', email: 'bob@example.com', role: 'admin', phone: '5551234567' },
        //   { id: 4, name: 'Emma Watson', email: 'emma@example.com', role: 'student', syllabus: 'ICSE', grade: '12', student_subject: 'Arts', phone: '4445556666' },
        //   { id: 5, name: 'Michael Brown', email: 'michael@example.com', role: 'tutor', qualification: 'B.Sc Physics', tutor_subject: 'Physics', experience: '3 years', phone: '7778889999' },
        // ];
        setUsers(mockUsers.data.filter(user => ['student'].includes(user.role)));
        setLoading(false);
      }, 1000);
    };
    fetchData();
  }, []);

  const getRoleColor = (role) => {
    switch(role) {
      case 'student': return 'bg-blue-500';
      case 'tutor': return 'bg-green-500';
      case 'admin': return 'bg-red-500';
      default: return 'bg-gray-500';
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <span className="loading loading-spinner loading-lg text-primary"></span>
      </div>
    );
  }

  return (
    <div className="p-1 bg-gray-100 min-h-screen">
      <h1 className="text-6xl text-center">👩‍🎓</h1>
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50 py-4 px-4">
      <div className="container mx-auto">
        <div className="text-center mb-10">
          <h1 className="text-3xl font-bold text-white mb-2 bg-secondary">Students</h1>
          {/* <p className="text-gray-600">Browse all registered users in the system</p> */}
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {users.map(user => (
            <Link
              key={user.id}
              to={`/student-dashboard/${user.id}`}
            >
              <div className="card bg-white shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                <div className="card-body p-6">
                  {/* Profile Avatar with large centered initial */}
                  <div className="flex justify-center -mt-14 mb-4">
                    <div className={`avatar placeholder ${getRoleColor(user.role)} text-white rounded-full w-24 h-24 flex items-center justify-center shadow-md border-4 border-white`}>
                    <span className="text-4xl font-bold">{user.name.charAt(0).toUpperCase()}</span>
                  </div>
                </div>
                
                {/* User name and role */}
                <div className="text-center mb-4">
                  <h2 className="text-2xl font-bold text-gray-800">{user.name}</h2>
                  <div className={`badge ${user.role === 'student' ? 'badge-success' : user.role === 'tutor' ? 'badge-success' : 'badge-error'} text-white mt-2 py-3 px-4 text-sm`}>
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2" />
                    </svg>
                    <span className="font-semibold">ID:</span>
                    <span className="ml-1">{user.id}</span>
                  </div>
                </div>
                
                {/* User details */}
                <div className="space-y-3 text-sm">
                  {/* <div className="flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2" />
                    </svg>
                    <span className="font-semibold">ID:</span>
                    <span className="ml-1">{user.id}</span>
                  </div>
                   */}
                  {/* <div className="flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                    <span className="truncate">{user.email}</span>
                  </div>
                   */}
                  {/* {user.phone && (
                    <div className="flex items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                      </svg>
                      <span>{user.phone}</span>
                    </div>
                  )}
                   */}
                  {/* Role-specific details */}
                  {user.role === 'student' && (
                    <>
                      <div className="border-t pt-3 mt-3">
                        {/* <h3 className="font-semibold text-gray-700 mb-2">Student Details</h3> */}
                        <div className="grid grid-cols-2 gap-2">
                          <div>
                            <span className="text-xs text-gray-500">Syllabus</span>
                            <p>{user.syllabus}</p>
                          </div>
                          <div>
                            <span className="text-xs text-gray-500">Grade</span>
                            <p>{user.grade}</p>
                          </div>
                          <div className="col-span-2">
                            <span className="text-xs text-gray-500">Subject</span>
                            <p>{user.student_subject}</p>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  
                  {user.role === 'tutor' && (
                    <>
                      <div className="border-t pt-3 mt-3">
                        <h3 className="font-semibold text-gray-700 mb-2">Tutor Details</h3>
                        <div className="space-y-2">
                          <div>
                            <span className="text-xs text-gray-500">Qualification</span>
                            <p>{user.qualification}</p>
                          </div>
                          <div>
                            <span className="text-xs text-gray-500">Subject</span>
                            <p>{user.tutor_subject}</p>
                          </div>
                          <div>
                            <span className="text-xs text-gray-500">Experience</span>
                            <p>{user.experience}</p>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
    </div>
  );
};

export default StudentCards;